// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27%3E%3Cpath fill=%27%23c2410c%27 d=%27M1 1l4 4 4-4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  padding: 1rem 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  gap: 1rem;
  flex-wrap: wrap;
}

/* Desktop: navbar-primary se "disuelve" y sus hijos van directo al flex del navbar.
   Con flex order reubicamos el zone-control-wrapper entre logo y navbar-center
   para mantener el layout previo (back | logo | zona | filtros | lista). */
.navbar-primary {
  display: contents;
}

.navbar-left {
  order: 1;
}

.navbar-left .p-button {
  color: #fa7317;
}

.navbar-left .p-button .p-button-icon {
  color: #fa7317;
  font-size: 1.1rem;
}

.navbar-left .p-button:hover {
  color: #e06312;
  background: #fff8f4;
}

.navbar-left .p-button:hover .p-button-icon {
  color: #e06312;
}
.logo {
  order: 2;
}
.zone-control-wrapper {
  order: 3;
}
.navbar-center {
  order: 4;
}
.navbar-right {
  order: 5;
}

/* ---------- Tablet ---------- */
@media (max-width: 1024px) {
  .navbar {
    padding: 0.75rem 1rem;
    gap: 0.5rem;
  }
  .logo img {
    max-height: 28px;
  }
}

/* ---------- Mobile ---------- */
@media (max-width: 768px) {
  /* Navbar: UNA sola fila, compacta. Los chips de filtros activos
     se renderizan como barra flotante ENCIMA del mapa (no dentro del navbar). */
  .navbar {
    padding: 0.6rem 0.75rem;
    gap: 0.5rem;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
  }

  .navbar-left,
  .logo,
  .zone-control-wrapper,
  .navbar-center,
  .navbar-right {
    flex-shrink: 0;
  }

  /* Switch Radio/Zonas queda inline dentro del navbar.
     Sacamos la barra de radio y el texto de conteo — la switch basta. */
  .zone-control-wrapper {
    margin-left: 4px !important;
    gap: 6px !important;
  }
  .zone-control-wrapper .radius-controls,
  .zone-control-wrapper .polygons-count {
    display: none !important;
  }

  .logo img {
    max-height: 26px;
  }

  .main-filters {
    flex-wrap: nowrap;
    gap: 2px;
  }

  /* Botones icon-only en mobile: Filtros outline, Lista CTA sólido. */
  .nav-btn-filters {
    color: #fa7317 !important;
    background: #fff !important;
    border: 1px solid rgba(250, 115, 23, 0.45) !important;
    width: 40px;
    height: 40px;
    padding: 0 !important;
    justify-content: center !important;
  }
  .nav-btn-filters--active {
    background: #fff8f4 !important;
    border-color: #fa7317 !important;
  }
  .nav-btn-filters .p-button-label {
    display: none !important;
  }
  .nav-btn-filters .p-button-icon {
    margin: 0 !important;
    font-size: 18px;
    color: #fa7317;
  }

  .nav-btn-list--primary {
    color: #fff !important;
    background: #fa7317 !important;
    border: 1px solid #fa7317 !important;
    box-shadow: 0 2px 6px rgba(250, 115, 23, 0.35);
    width: 40px;
    height: 40px;
    padding: 0 !important;
    justify-content: center !important;
  }
  .nav-btn-list .p-button-label {
    display: none !important;
  }
  .nav-btn-list .p-button-icon {
    margin: 0 !important;
    font-size: 18px;
    color: #fff !important;
  }

  /* Crear nuevo reporte desaparece en mobile */
  .nav-btn-create {
    display: none !important;
  }

  .navbar-right {
    margin-left: auto;
  }

  /* Panel avanzado: overlay fixed por debajo del navbar (~60px). */
  .advanced-filters-panel {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    width: 100vw;
    max-height: calc(100vh - 60px);
    overflow-y: auto;
    background: #fff8f4;
    border-top: 2px solid rgba(250, 115, 23, 0.35);
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
    z-index: 1001;
    padding: 12px;
  }

  .filters-grid {
    grid-template-columns: 1fr !important;
    gap: 12px;
  }

  /* Chips flotantes: barra fija debajo del navbar, sobre el mapa.
     Una sola fila con scroll horizontal. */
  .active-filters {
    position: fixed !important;
    top: 60px !important;
    left: 0;
    right: 0;
    padding: 0.4rem 0.6rem;
    margin: 0;
    gap: 0.4rem;
    flex-wrap: nowrap !important;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
    background: transparent; /* flota sobre el mapa */
    z-index: 998;
    pointer-events: none; /* los gaps entre chips dejan pasar clicks al mapa */
  }
  .active-filters::-webkit-scrollbar {
    height: 0;
    display: none;
  }
  .active-filters {
    scrollbar-width: none;
  }

  .filter-chip {
    flex-shrink: 0;
    pointer-events: auto; /* los chips sí son interactivos */
    background: #fff;
    border: 2px solid rgba(250, 115, 23, 0.55);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }
}

.main-filters {
  display: flex;
  gap: 1rem;
  align-items: center;
  position: relative;
}

/* Switch de modo de búsqueda Radio/Zonas */
.search-mode-toggle {
  display: inline-flex;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 2px;
}

.search-mode-toggle .smt-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: 13px;
  font-weight: 500;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.search-mode-toggle .smt-btn:hover:not(:disabled) {
  color: #fa7317;
}

.search-mode-toggle .smt-btn.active {
  background: #ffffff;
  color: #fa7317;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.search-mode-toggle .smt-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.search-mode-toggle .smt-btn:focus,
.search-mode-toggle .smt-btn:focus-visible {
  outline: none;
  box-shadow: none;
}

.search-mode-toggle .smt-btn i {
  font-size: 12px;
}

.search-mode-toggle .smt-badge {
  display: inline-block;
  min-width: 18px;
  padding: 0 5px;
  background: #fa7317;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  border-radius: 999px;
  text-align: center;
  line-height: 18px;
}

/* Slider de radio — relleno progresivo naranja */
.radius-controls .radius-slider,
.zone-control-wrapper .radius-slider {
  appearance: none;
  width: 160px;
  height: 16px;
  background: transparent;
  cursor: pointer;
}

.radius-controls .radius-slider::-webkit-slider-runnable-track,
.zone-control-wrapper .radius-slider::-webkit-slider-runnable-track {
  height: 6px;
  border-radius: 999px;
  background: linear-gradient(
    to right,
    #fa7317 0%,
    #fa7317 var(--radius-fill, 0%),
    #ffedd5 var(--radius-fill, 0%),
    #ffedd5 100%
  );
}

.radius-controls .radius-slider::-webkit-slider-thumb,
.zone-control-wrapper .radius-slider::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  margin-top: -5px;
  border-radius: 50%;
  background: #fa7317;
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(250, 115, 23, 0.45);
  cursor: pointer;
}

.radius-controls .radius-slider::-moz-range-progress,
.zone-control-wrapper .radius-slider::-moz-range-progress {
  height: 6px;
  border-radius: 999px 0 0 999px;
  background: #fa7317;
}

.radius-controls .radius-slider::-moz-range-track,
.zone-control-wrapper .radius-slider::-moz-range-track {
  height: 6px;
  border-radius: 999px;
  background: #ffedd5;
}

.radius-controls .radius-slider::-moz-range-thumb,
.zone-control-wrapper .radius-slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border: none;
  border-radius: 50%;
  background: #fa7317;
  box-shadow: 0 1px 4px rgba(250, 115, 23, 0.45);
  cursor: pointer;
}

.transaction-filter {
  display: flex;
  gap: 0.5rem;

  button {
    padding: 0.5rem 1rem;

    &.active {
      margin: 0;
      display: inline-flex;
      cursor: pointer;
      -webkit-user-select: none;
              user-select: none;
      align-items: center;
      vertical-align: bottom;
      text-align: center;
      overflow: hidden;
      position: relative;
      background: #fa7317;
      color: white;
      border-color: #fa7317;
      font-weight: bold;
    }
  }
}

.transaction-buttons {
  display: flex;
  gap: 0.5rem;

  button {
    padding: 0.5rem 1rem;

    &.active {
      margin: 0;
      display: inline-flex;
      cursor: pointer;
      -webkit-user-select: none;
              user-select: none;
      align-items: center;
      vertical-align: bottom;
      text-align: center;
      overflow: hidden;
      position: relative;
      background: #fa7317;
      color: white;
      border-color: #fa7317;
      font-weight: bold;
    }
  }
}
.advanced-filters-panel {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: linear-gradient(180deg, #fff8f4 0%, #fff 100%);
  padding: 0.85rem 1.25rem 1rem;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
  border-top: 2px solid rgba(250, 115, 23, 0.4);
  border-radius: 0 0 14px 14px;
  z-index: 999;
  --filter-control-h: 44px;
}

.filters-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 1.35fr) minmax(0, 1.05fr) minmax(0, 1.2fr);
  gap: 0.75rem;
  align-items: stretch;
}

.filter-section {
  padding: 0.9rem 0.95rem 1rem;
  border-radius: 12px;
  background: linear-gradient(155deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 247, 237, 0.7) 100%);
  border: 1px solid rgba(250, 115, 23, 0.16);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  min-height: 0;
}

.filter-section__title {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
  padding-bottom: 0.45rem;
  border-bottom: 1px solid rgba(250, 115, 23, 0.12);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #c2410c;
  line-height: 1.2;
}

.filter-section__title i {
  font-size: 0.78rem;
  color: #fa7317;
}

.filter-fields-stack {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex: 1 1;
}

.filter-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.filter-field--row {
  display: grid;
  grid-template-columns: 6.2rem minmax(0, 1fr);
  align-items: center;
  column-gap: 0.65rem;
  min-height: 44px;
}

.filter-field--row label {
  display: flex;
  align-items: center;
  align-self: center;
  min-height: 44px;
  margin: 0;
  font-size: 0.82rem;
  font-weight: 650;
  color: #475569;
  line-height: 1.2;
}

.filter-field--row .input-group {
  display: flex;
  align-items: center;
  min-width: 0;
  height: var(--filter-control-h);
}

.filter-field label {
  font-size: 0.72rem;
  font-weight: 600;
  color: #64748b;
  line-height: 1.2;
}

.price-filter-row {
  min-height: var(--filter-control-h);
}

.price-filter-row .input-group--price {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  width: 100%;
  height: var(--filter-control-h);
}

.styled-select--currency {
  flex: 1 1 100%;
  width: 100%;
  min-width: 0;
  height: 44px;
  padding: 0 36px 0 14px;
  font-size: 16px;
  text-align: left;
  text-align-last: left;
  box-sizing: border-box;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 14px center;
  background-color: #fff;
}

.input-group--price .styled-input {
  flex: 1 1;
  min-width: 0;
}

.filter-amenities {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.55rem;
}

.filter-amenity-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 44px;
  padding: 0.55rem 0.7rem;
  border: 1px solid rgba(250, 115, 23, 0.16);
  border-radius: 12px;
  background: #fff;
  color: #334155;
  font-size: 0.86rem;
  font-weight: 650;
  line-height: 1.2;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  white-space: nowrap;
}

.filter-amenity-chip__icon {
  font-size: 0.72rem;
  line-height: 1;
}

.filter-amenity-chip:hover {
  border-color: rgba(250, 115, 23, 0.45);
}

.filter-amenity-chip--active,
.filter-amenity-chip--active:hover {
  background: rgba(250, 115, 23, 0.1);
  border-color: #fa7317;
  color: #c2410c;
  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.12);
}

.filter-amenity-chip:focus,
.filter-amenity-chip:focus-visible {
  outline: none;
  box-shadow: none;
}

.filter-parking-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 0.15rem;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(250, 115, 23, 0.12);
  min-height: 44px;
}

.filter-parking-row > span {
  font-size: 0.86rem;
  font-weight: 650;
  color: #334155;
}

.filter-stepper {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.filter-stepper__btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(250, 115, 23, 0.16);
  border-radius: 12px;
  background: #fff;
  color: #c2410c;
  font-size: 0;
  line-height: 0;
  cursor: pointer;
}

.filter-stepper__btn::before,
.filter-stepper__btn--plus::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  background: currentColor;
  border-radius: 1px;
  transform: translate(-50%, -50%);
}

.filter-stepper__btn::before {
  width: 12px;
  height: 2px;
}

.filter-stepper__btn--plus::after {
  width: 2px;
  height: 12px;
}

.filter-stepper__btn:hover:not(:disabled) {
  background: #fa7317;
  color: #fff;
}

.filter-stepper__btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  color: #94a3b8;
}

.filter-stepper__value {
  min-width: 1.5rem;
  text-align: center;
  font-size: 0.95rem;
  font-weight: 750;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

.filter-parking-row label {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  height: var(--filter-control-h);
  font-size: 0.7rem;
  font-weight: 600;
  color: #64748b;
  margin: 0;
  flex-shrink: 0;
}

.styled-input--parking {
  flex: 0 0 4.5rem;
  width: 4.5rem;
  max-width: 4.5rem;
  height: var(--filter-control-h);
}

.advanced-filters-panel input[type="number"]::-webkit-inner-spin-button,
.advanced-filters-panel input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.advanced-filters-panel input[type="number"] {
  appearance: textfield;
}

@media (max-width: 1280px) {
  .filters-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .filter-section--amenities {
    grid-column: 1 / -1;
  }
}

@media (max-width: 960px) {
  .filters-grid {
    grid-template-columns: 1fr;
  }

  .filter-section--amenities {
    grid-column: auto;
  }

  .filter-field--row {
    grid-template-columns: 4.8rem 1fr;
  }

  .price-filter-row .input-group--price {
    flex-wrap: wrap;
    height: auto;
    min-height: var(--filter-control-h);
  }

  .styled-select--currency {
    flex: 1 1 100%;
    width: 100%;
    min-width: 0;
  }
}

.slider-filter {
  margin: 1rem 0;

  input[type="range"] {
    width: 100%;
  }
}

.amenities-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;

  label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
  }
}
.filter-group {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  padding: 1rem;
}

.filter-group label {
  font-weight: bold;
  color: #374151;
}

.filter-group input,
.filter-group select {
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 1rem;
  color: #374151;
}

.filter-group input:focus,
.filter-group select:focus {
  outline: none;
  border-color: #fa7317;
  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.3);
}

.filter-actions {
  display: flex;
  justify-content: flex-initial;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}
/* Selector de tipos de propiedad */
.type-filter {
  width: 240px !important;
  min-width: 240px !important;

  .p-multiselect-label {
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
    padding-right: 2rem;
  }

  .p-multiselect-token {
    flex-shrink: 0;
    margin: 2px;
  }

  .p-multiselect-items-wrapper {
    &::-webkit-scrollbar {
      height: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 4px;
    }
  }
}

/* Contenedor de chips con scroll horizontal */
.p-multiselect-panel .p-multiselect-items {
  display: flex !important;
  flex-wrap: nowrap !important;
  overflow-x: auto !important;
  padding-bottom: 8px;
}

/* Panel desplegable más ancho */
.property-types-panel {
  min-width: 400px !important;

  .p-multiselect-item {
    white-space: nowrap;
  }
}

/* Scroll horizontal para los chips seleccionados */
.p-multiselect-label-container {
  overflow-x: auto !important;
  flex-wrap: nowrap !important;
  padding-bottom: 4px;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 2px;
  }
}
/* properties-sidebar */
.properties-sidebar {
  width: min(90vw, 600px) !important;
  height: 100vh !important;
  transition: transform 0.3s ease !important;

  &.p-sidebar {
    box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
    border-left: 1px solid #ddd;
  }

  .p-sidebar-content {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #eee;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 10;

  h3 {
    margin: 0;
    font-size: 1.2rem;
  }

  button {
    color: #666;

    &:hover {
      color: #3b82f6;
    }
  }
}
/* SCOPED al .navbar — antes era un selector global .p-button que pisaba
   TODOS los botones de PrimeReact en la app, incluyendo Generar PDF /
   Excel del editor del informe. Esos quedaban como letras grises sin
   contorno porque hereaban background:none + border:none. */
.navbar .p-button {
  color: #6b7280;
  background: none;
  border: none;
  padding: 0.75rem 1.25rem;
  font-size: 1rem;
  transition:
    background-color 0.2s,
    color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
  border-radius: 6px;
}

/* Botones de acción del navbar — jerarquía visual */
.navbar .nav-btn-filters,
.navbar .nav-btn-create,
.navbar .nav-btn-list {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: 8px;
  border: 1px solid transparent;
}

.navbar .nav-btn-filters {
  color: #fa7317;
  background: #fff;
  border-color: rgba(250, 115, 23, 0.45);
}

.navbar .nav-btn-filters:hover,
.navbar .nav-btn-filters--active {
  color: #fa7317;
  background: #fff8f4;
  border-color: #fa7317;
}

.navbar .nav-btn-filters:focus,
.navbar .nav-btn-filters:focus-visible,
.navbar .nav-btn-filters.p-focus,
.navbar .nav-btn-create:focus,
.navbar .nav-btn-create:focus-visible,
.navbar .nav-btn-create.p-focus,
.navbar .nav-btn-list:focus,
.navbar .nav-btn-list:focus-visible,
.navbar .nav-btn-list.p-focus,
.navbar .p-button-text:focus,
.navbar .p-button-text:focus-visible,
.navbar .p-button-text.p-focus {
  outline: none !important;
  box-shadow: none !important;
}

.navbar .nav-btn-filters .p-button-icon {
  color: #fa7317;
}

.navbar .nav-btn-create {
  color: #374151;
  background: #f3f4f6;
  border-color: #e5e7eb;
}

.navbar .nav-btn-create:hover {
  color: #374151;
  background: #e9ecef;
  border-color: #d1d5db;
}

.navbar .nav-btn-create .p-button-icon {
  color: #6b7280;
}

.navbar .nav-btn-list--primary {
  color: #fff;
  background: #fa7317;
  border-color: #fa7317;
  box-shadow: 0 2px 8px rgba(250, 115, 23, 0.35);
  padding: 0.6rem 1.15rem;
}

.navbar .nav-btn-list--primary:hover {
  color: #fff;
  background: #e06312;
  border-color: #e06312;
  box-shadow: 0 4px 12px rgba(250, 115, 23, 0.4);
}

.navbar .nav-btn-list--primary .p-button-icon {
  color: #fff;
}

.navbar .nav-btn-list--primary .p-button-label {
  color: #fff;
}
.active-filters {
  position: fixed;
  top: 70px;
  left: 0;
  right: 0;
  padding: 1rem 2rem;
  z-index: 1;
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.filter-chip {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #ffffff;
  padding: 0.1rem 1rem;
  border-radius: 20px;
  font-size: 0.7rem;
  border: 2px solid rgba(250, 115, 23, 0.55);
}

.button-group-filter {
  margin: 1rem 0;
}

.button-group {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.advanced-filters-panel .button-group .p-button {
  min-width: 0;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 0.2rem);
  padding: 0.4rem 0.5rem;
  font-size: 0.72rem;
  font-weight: 600;
  border-radius: 999px;
  border: 1.5px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
}

.advanced-filters-panel .button-group .p-button:hover {
  border-color: rgba(250, 115, 23, 0.45);
  color: #c2410c;
  background: #fff8f4;
}

.advanced-filters-panel .button-group .p-button.active {
  background: #fa7317;
  color: #fff;
  border-color: #fa7317;
  box-shadow: 0 2px 6px rgba(250, 115, 23, 0.3);
}

.styled-input {
  flex: 1 1;
  min-width: 0;
  width: 100%;
  height: 44px;
  padding: 0 14px;
  border: 1px solid rgba(250, 115, 23, 0.16);
  border-radius: 12px;
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  color: #0f172a;
  background: #fff;
  box-sizing: border-box;
  line-height: 1.2;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.styled-input:focus {
  outline: none;
  border-color: #fa7317;
  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.12);
}

.styled-input--compact {
  max-width: 100%;
}

.styled-select {
  width: 100%;
  height: 44px;
  padding: 0 36px 0 14px;
  border: 1px solid rgba(250, 115, 23, 0.16);
  border-radius: 12px;
  background-color: #fff;
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  box-sizing: border-box;
  line-height: 1.2;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.styled-select:focus {
  outline: none;
  border-color: #fa7317;
  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.12);
}

.small-input {
  width: 60px !important;
  max-width: 60px;
  margin-top: 5px;
}

.price-filter-container {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.input-group {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex-wrap: nowrap;
  width: 100%;
}

.input-group .separator {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  align-self: center;
  height: var(--filter-control-h, 2rem);
  color: #c2410c;
  font-weight: 600;
  font-size: 0.85rem;
  line-height: 1;
}

.currency-selector,
.price-inputs {
  width: 100%;
}
.logo img {
  height: 40px; /* Ajusta según tu diseño */
  width: auto;
  cursor: pointer;
}

/* Home navigation: brand a la izquierda, zona y acciones a la derecha. */
.home-page .navbar {
  position: relative;
  inset: auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 auto;
  padding: 12px 20px;
  gap: 10px 16px;
  z-index: 20;
  box-shadow: none;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
}
.home-page .navbar-brand {
  display: flex;
  align-items: center;
  gap: 2px;
  min-width: 0;
  flex: 0 0 auto;
}
.home-page .navbar-tools {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-left: auto;
  min-width: 0;
  flex: 1 1 auto;
}
.home-page .navbar-center { display: contents; }
.home-page .navbar-left .p-button { width: 32px; height: 38px; padding: 0; justify-content: center; }
.home-page .navbar .logo { display: flex; align-items: center; margin: 0; padding: 0; }
.home-page .navbar .logo img { display: block; width: 108px; height: auto; max-height: 36px; object-fit: contain; }
.home-page .main-filters { gap: 12px; flex-shrink: 0; }
.home-page .navbar .nav-btn-filters,
.home-page .navbar .nav-btn-create {
  display: inline-flex !important;
  min-height: 40px;
  padding: 9px 14px;
  font-size: 13px;
  white-space: nowrap;
}
.home-page .navbar .nav-btn-filters { width: auto; height: auto; }
.home-page .navbar .nav-btn-filters .p-button-label { display: inline !important; }
.home-page .navbar .nav-btn-filters .p-button-icon { margin-right: 6px !important; }
.nav-filters-wrap { position: relative; display: inline-flex; }
@keyframes nav-filters-updated {
  0% { box-shadow: 0 0 0 0 rgba(250, 115, 23, 0.4); }
  45% { box-shadow: 0 0 0 7px rgba(250, 115, 23, 0); background: #fff7ed; }
  100% { box-shadow: 0 0 0 0 rgba(250, 115, 23, 0); }
}
@keyframes nav-filters-count-pop {
  0% { transform: scale(1); }
  35% { transform: scale(1.2); }
  100% { transform: scale(1); }
}
.nav-filters-wrap--updated .nav-btn-filters {
  animation: nav-filters-updated 0.9s ease;
}
.nav-filters-wrap--updated .nav-filters-count {
  animation: nav-filters-count-pop 0.9s ease;
}
@media (prefers-reduced-motion: reduce) {
  .nav-filters-wrap--updated .nav-btn-filters,
  .nav-filters-wrap--updated .nav-filters-count {
    animation: none;
  }
}
.nav-filters-count {
  position: absolute;
  top: -6px;
  right: -6px;
  z-index: 1;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #c2410c;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  pointer-events: none;
}
.home-page .zone-control-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1 280px;
  max-width: 460px;
  min-width: 0;
  margin: 0 !important;
  padding: 6px 10px;
  border: 1px solid rgba(250, 115, 23, 0.16);
  border-radius: 12px;
  background: linear-gradient(155deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 247, 237, 0.7) 100%);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);
}
.home-page .search-mode-toggle { flex: 0 0 auto; background: rgba(255, 255, 255, 0.7); }
.home-page .search-mode-toggle .smt-btn { padding: 7px 11px; font-size: 12px; }
.home-page .zone-control-wrapper .radius-controls { display: flex !important; align-items: center; gap: 8px; flex: 1 1; min-width: 0; }
.home-page .radius-controls__value { min-width: 52px; color: #78716c; font-size: 12px; text-align: right; }
.home-page .radius-slider { flex: 1 1; min-width: 80px; width: 100%; }

.filter-drawer-backdrop {
  position: fixed;
  top: var(--home-nav-bottom, 72px);
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 39;
  border: 0;
  padding: 0;
  background: rgba(15, 23, 42, 0.28);
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.42s ease;
}
.filter-drawer-backdrop.is-open {
  opacity: 1;
  pointer-events: auto;
}
.home-page .filter-drawer {
  position: fixed;
  top: var(--home-nav-bottom, 72px);
  right: 0;
  bottom: 0;
  left: auto;
  z-index: 40;
  display: flex;
  flex-direction: column;
  width: min(100%, clamp(440px, 44vw, 680px));
  max-height: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  border: 0;
  border-left: 1px solid rgba(250, 115, 23, 0.16);
  border-radius: 0;
  background: #fff;
  box-shadow: -16px 0 40px rgba(15, 23, 42, 0.14);
  transform: translateX(100%);
  pointer-events: none;
  transition: transform 0.42s cubic-bezier(0.22, 1, 0.36, 1);
}
.home-page .filter-drawer.is-open {
  transform: translateX(0);
  pointer-events: auto;
}
.filter-drawer__form {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}
.filter-drawer .filters-grid { grid-template-columns: 1fr; }
.filter-drawer .price-filter-row,
.filter-drawer .price-filter-row .input-group--price {
  height: auto;
  min-height: 0;
}
.filter-drawer .price-filter-row .input-group--price {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  gap: 8px;
}
.filter-drawer .styled-select--currency { grid-column: 1 / -1; }
.filter-drawer .active-filters {
  position: static !important;
  inset: auto !important;
  top: auto !important;
  right: auto !important;
  left: auto !important;
  display: flex;
  flex-wrap: wrap !important;
  gap: 8px;
  width: auto;
  max-height: none;
  margin: 0 0 14px;
  padding: 0;
  overflow: visible;
  background: transparent;
  pointer-events: auto;
  z-index: auto;
}
.filter-drawer .filter-chip {
  flex-shrink: 1;
  max-width: 100%;
  padding: 4px 4px 4px 10px;
  border: 1px solid rgba(250, 115, 23, 0.22);
  border-radius: 12px;
  background: #fff;
  color: #334155;
  box-shadow: none;
  font-size: 12px;
}
.filter-drawer .filter-chip span {
  display: block;
  min-width: 0;
  max-width: min(100%, 280px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.filter-drawer .filter-chip .p-button {
  flex-shrink: 0;
  min-width: 28px;
  width: 28px;
  height: 28px;
  padding: 0;
  justify-content: center;
}
.filter-editor-heading { display: flex; align-items: center; justify-content: space-between; flex-shrink: 0; padding: 16px 20px 12px; gap: 16px; }
.filter-editor-heading h2 { margin: 0; color: #334155; font-size: 16px; }
.filter-editor-heading p { margin: 5px 0 0; color: #78716c; font-size: 12px; }
.filter-editor-close { width: 32px; height: 32px; flex: 0 0 auto; border: 0; border-radius: 8px; color: #78716c; background: #f2ede7; cursor: pointer; }
.filter-editor-body { min-height: 0; overflow-y: auto; padding: 0 20px 16px; overscroll-behavior: contain; }
.filter-editor-footer { display: flex; align-items: center; justify-content: space-between; gap: 16px; flex-shrink: 0; padding: 12px 20px; border-top: 1px solid #f0dfd0; background: #fff; }
.filter-editor-status { font-size: 12px; color: #78716c; }
.filter-editor-error { color: #b91c1c; }
.filter-editor-actions { display: flex; align-items: center; gap: 10px; flex-shrink: 0; }
.filter-editor-actions button { min-height: 44px; padding: 9px 16px; border-radius: 12px; font: inherit; font-size: 14px; font-weight: 650; cursor: pointer; }
.filter-drawer .filter-editor-footer { flex-direction: column; align-items: stretch; gap: 10px; }
.filter-drawer .filter-editor-actions { display: grid; grid-template-columns: 1fr 1.35fr; }
.filter-editor-cancel { color: #c2410c; background: #fff; border: 1px solid rgba(250, 115, 23, 0.45); }
.filter-editor-apply {
  color: #fff;
  border: none;
  background: linear-gradient(135deg, #fa7317 0%, #c2410c 100%);
  box-shadow: 0 4px 12px rgba(250, 115, 23, 0.25);
}
.filter-editor-apply:disabled { opacity: .5; cursor: not-allowed; box-shadow: none; }
.filter-editor-apply:hover:not(:disabled) {
  color: #fff;
  background: linear-gradient(135deg, #fa7317 0%, #c2410c 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(250, 115, 23, 0.35);
}
.filter-editor-actions button:focus-visible { outline: 2px solid #a65320 !important; outline-offset: 3px; }

.polygon-expansion { flex: 1 1; min-width: 0; }
.polygon-expansion__heading { display: flex; justify-content: space-between; align-items: center; gap: 8px; font-size: 11px; color: #78716c; }
.polygon-expansion__heading label { font-weight: 600; }
.polygon-expansion__heading output { color: #a85d2d; font-weight: 700; white-space: nowrap; }
.polygon-expansion__row { display: flex; align-items: center; gap: 7px; }
.polygon-expansion__reset { flex: 0 0 26px; width: 26px; height: 26px; padding: 0; border: 1px solid #f2d6bd; border-radius: 6px; background: #fffaf5; color: #a85d2d; cursor: pointer; }
.polygon-expansion__reset:disabled { opacity: .4; cursor: default; }
.polygon-expansion__reset:focus-visible, .home-page .radius-slider:focus-visible { outline: 2px solid #c8753c !important; outline-offset: 3px; }

@media (max-width: 980px) {
  .home-page .navbar-tools { display: contents; }
  .home-page .navbar-brand { order: 1; }
  .home-page .main-filters { order: 2; margin-left: auto; }
  .home-page .zone-control-wrapper {
    order: 3;
    flex: 1 1 100%;
    max-width: none;
  }
}
@media (max-width: 600px) {
  .home-page .navbar { padding: 10px 12px; gap: 10px; }
  .home-page .navbar .logo img { width: 86px; max-height: 30px; }
  .home-page .navbar-left .p-button { width: 26px; }
  .home-page .main-filters { gap: 8px; }
  .home-page .navbar .nav-btn-filters { min-height: 40px; padding: 8px 10px; }
  .home-page .navbar .nav-btn-create { width: 40px; height: 40px; min-height: 40px; padding: 0; justify-content: center; }
  .home-page .navbar .nav-btn-create .p-button-label { display: none; }
  .home-page .navbar .nav-btn-create .p-button-icon { margin: 0; }
  .home-page .zone-control-wrapper { gap: 10px !important; padding: 7px 8px; }
  .home-page .search-mode-toggle .smt-btn { padding: 6px 8px; font-size: 11px; gap: 4px; }
  .home-page .filter-drawer { width: 100%; border-left: 0; }
  .filter-editor-heading { padding: 12px; }
  .filter-editor-heading h2 { font-size: 15px; }
  .filter-editor-body { padding: 0 12px 12px; }
  .filter-editor-footer { padding: 10px 12px; }
  .filter-field--row { grid-template-columns: 1fr; row-gap: 6px; }
  .filter-field--row label { min-height: 0; }
}
@media (prefers-reduced-motion: reduce) {
  .filter-drawer-backdrop,
  .home-page .filter-drawer {
    transition: none;
  }
}
@media (max-width: 420px) {
  .home-page .navbar .nav-btn-filters .p-button-label { display: none !important; }
  .home-page .navbar .nav-btn-filters { width: 40px; height: 40px; padding: 0 !important; justify-content: center; }
  .home-page .navbar .nav-btn-filters .p-button-icon { margin: 0 !important; }
  .filter-drawer .filter-editor-actions { grid-template-columns: 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Navbar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;2EAE2E;AAC3E;EACE,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;;AAEA,iCAAiC;AACjC;EACE;IACE,qBAAqB;IACrB,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC;EACE;gFAC8E;EAC9E;IACE,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;;;;;IAKE,cAAc;EAChB;;EAEA;wEACsE;EACtE;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA,oEAAoE;EACpE;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,qDAAqD;IACrD,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;EACpC;EACA;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;IACpB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,oCAAoC;IACpC,8CAA8C;IAC9C,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;EACpC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;IACpB,eAAe;IACf,sBAAsB;EACxB;;EAEA,6CAA6C;EAC7C;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA,iEAAiE;EACjE;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,8CAA8C;IAC9C,6CAA6C;IAC7C,aAAa;IACb,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;2CACyC;EACzC;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,OAAO;IACP,QAAQ;IACR,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,mBAAmB;IACnB,uBAAuB,EAAE,wBAAwB;IACjD,YAAY;IACZ,oBAAoB,EAAE,oDAAoD;EAC5E;EACA;IACE,SAAS;IACT,aAAa;EACf;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,oBAAoB,EAAE,kCAAkC;IACxD,gBAAgB;IAChB,0CAA0C;IAC1C,yCAAyC;EAC3C;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;;EAGE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,oBAAoB;EACpB;;;;;;GAMC;AACH;;AAEA;;EAGE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;;EAEX;IACE,oBAAoB;;IAEpB;MACE,SAAS;MACT,oBAAoB;MACpB,eAAe;MACf,yBAAiB;cAAjB,iBAAiB;MACjB,mBAAmB;MACnB,sBAAsB;MACtB,kBAAkB;MAClB,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;MACnB,YAAY;MACZ,qBAAqB;MACrB,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE,aAAa;EACb,WAAW;;EAEX;IACE,oBAAoB;;IAEpB;MACE,SAAS;MACT,oBAAoB;MACpB,eAAe;MACf,yBAAiB;cAAjB,iBAAiB;MACjB,mBAAmB;MACnB,sBAAsB;MACtB,kBAAkB;MAClB,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;MACnB,YAAY;MACZ,qBAAqB;MACrB,iBAAiB;IACnB;EACF;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,0DAA0D;EAC1D,6BAA6B;EAC7B,8CAA8C;EAC9C,6CAA6C;EAC7C,4BAA4B;EAC5B,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,6FAA6F;EAC7F,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gGAAgG;EAChG,0CAA0C;EAC1C,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,yDAAwL;EACxL,4BAA4B;EAC5B,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,SAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0DAA0D;EAC1D,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;EACd,8CAA8C;AAChD;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,wBAAwB;EACxB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,mCAAmC;EACrC;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,cAAc;;EAEd;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;;EAEX;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;EACT,iBAAiB;EACjB,0BAA0B;AAC5B;AACA,mCAAmC;AACnC;EACE,uBAAuB;EACvB,2BAA2B;;EAE3B;IACE,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE;MACE,WAAW;IACb;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;EACF;AACF;;AAEA,8CAA8C;AAC9C;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,2BAA2B;;EAE3B;IACE,mBAAmB;EACrB;AACF;;AAEA,mDAAmD;AACnD;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;;EAEnB;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;AACA,uBAAuB;AACvB;EACE,kCAAkC;EAClC,wBAAwB;EACxB,0CAA0C;;EAE1C;IACE,0CAA0C;IAC1C,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,WAAW;;EAEX;IACE,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,WAAW;;IAEX;MACE,cAAc;IAChB;EACF;AACF;AACA;;;4DAG4D;AAC5D;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf;;;;mBAIiB;EACjB,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;EAYE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;EAC9C,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAA4B;EAA5B,cAA4B;EAA5B,8BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,0CAA0C;EAC1C,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;AACA;EACE,YAAY,EAAE,2BAA2B;EACzC,WAAW;EACX,eAAe;AACjB;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;AACA,4BAA4B,iBAAiB,EAAE;AAC/C,oCAAoC,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,uBAAuB,EAAE;AACpG,2BAA2B,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,UAAU,EAAE;AACtF,+BAA+B,cAAc,EAAE,YAAY,EAAE,YAAY,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAClH,2BAA2B,SAAS,EAAE,cAAc,EAAE;AACtD;;EAEE,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;AACA,sCAAsC,WAAW,EAAE,YAAY,EAAE;AACjE,sDAAsD,0BAA0B,EAAE;AAClF,qDAAqD,4BAA4B,EAAE;AACnF,oBAAoB,kBAAkB,EAAE,oBAAoB,EAAE;AAC9D;EACE,KAAK,2CAA2C,EAAE;EAClD,MAAM,2CAA2C,EAAE,mBAAmB,EAAE;EACxE,OAAO,yCAAyC,EAAE;AACpD;AACA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,qBAAqB,EAAE;EAC7B,OAAO,mBAAmB,EAAE;AAC9B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,0CAA0C;EAC1C,mBAAmB;EACnB,gGAAgG;EAChG,8CAA8C;AAChD;AACA,iCAAiC,cAAc,EAAE,oCAAoC,EAAE;AACvF,0CAA0C,iBAAiB,EAAE,eAAe,EAAE;AAC9E,oDAAoD,wBAAwB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,SAAO,EAAE,YAAY,EAAE;AACpI,qCAAqC,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE;AAC1G,4BAA4B,SAAO,EAAE,eAAe,EAAE,WAAW,EAAE;;AAEnE;EACE,eAAe;EACf,iCAAiC;EACjC,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,SAAS;EACT,UAAU;EACV,kCAAkC;EAClC,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,2BAA2B;EAC3B,oBAAoB;EACpB,0DAA0D;AAC5D;AACA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;AACf;AACA,+BAA+B,0BAA0B,EAAE;AAC3D;;EAEE,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,yDAAyD;EACzD,QAAQ;AACV;AACA,0CAA0C,mBAAmB,EAAE;AAC/D;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,0BAA0B;EAC1B,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;AACzB;AACA,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,cAAc,EAAE,uBAAuB,EAAE,SAAS,EAAE;AACjJ,4BAA4B,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE;AACxE,2BAA2B,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAC7E,uBAAuB,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,SAAS,EAAE,kBAAkB,EAAE,cAAc,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACvJ,sBAAsB,aAAa,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,4BAA4B,EAAE;AAC3G,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,cAAc,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,gBAAgB,EAAE;AAC5L,wBAAwB,eAAe,EAAE,cAAc,EAAE;AACzD,uBAAuB,cAAc,EAAE;AACvC,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,cAAc,EAAE;AACxF,gCAAgC,gBAAgB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,aAAa,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC7J,uCAAuC,sBAAsB,EAAE,oBAAoB,EAAE,SAAS,EAAE;AAChG,wCAAwC,aAAa,EAAE,iCAAiC,EAAE;AAC1F,wBAAwB,cAAc,EAAE,gBAAgB,EAAE,0CAA0C,EAAE;AACtG;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,+CAA+C;AACjD;AACA,gCAAgC,WAAW,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACpF;EACE,WAAW;EACX,6DAA6D;EAC7D,2BAA2B;EAC3B,+CAA+C;AACjD;AACA,8CAA8C,qCAAqC,EAAE,mBAAmB,EAAE;;AAE1G,qBAAqB,SAAO,EAAE,YAAY,EAAE;AAC5C,8BAA8B,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,cAAc,EAAE;AAC7I,oCAAoC,gBAAgB,EAAE;AACtD,qCAAqC,cAAc,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC5F,0BAA0B,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACxE,4BAA4B,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE;AACxL,qCAAqC,WAAW,EAAE,eAAe,EAAE;AACnE,mFAAmF,qCAAqC,EAAE,mBAAmB,EAAE;;AAE/I;EACE,2BAA2B,iBAAiB,EAAE;EAC9C,2BAA2B,QAAQ,EAAE;EACrC,2BAA2B,QAAQ,EAAE,iBAAiB,EAAE;EACxD;IACE,QAAQ;IACR,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE,qBAAqB,kBAAkB,EAAE,SAAS,EAAE;EACpD,+BAA+B,WAAW,EAAE,gBAAgB,EAAE;EAC9D,oCAAoC,WAAW,EAAE;EACjD,2BAA2B,QAAQ,EAAE;EACrC,sCAAsC,gBAAgB,EAAE,iBAAiB,EAAE;EAC3E,qCAAqC,WAAW,EAAE,YAAY,EAAE,gBAAgB,EAAE,UAAU,EAAE,uBAAuB,EAAE;EACvH,qDAAqD,aAAa,EAAE;EACpE,oDAAoD,SAAS,EAAE;EAC/D,mCAAmC,oBAAoB,EAAE,gBAAgB,EAAE;EAC3E,0CAA0C,gBAAgB,EAAE,eAAe,EAAE,QAAQ,EAAE;EACvF,4BAA4B,WAAW,EAAE,cAAc,EAAE;EACzD,yBAAyB,aAAa,EAAE;EACxC,4BAA4B,eAAe,EAAE;EAC7C,sBAAsB,oBAAoB,EAAE;EAC5C,wBAAwB,kBAAkB,EAAE;EAC5C,qBAAqB,0BAA0B,EAAE,YAAY,EAAE;EAC/D,2BAA2B,aAAa,EAAE;AAC5C;AACA;EACE;;IAEE,gBAAgB;EAClB;AACF;AACA;EACE,sDAAsD,wBAAwB,EAAE;EAChF,sCAAsC,WAAW,EAAE,YAAY,EAAE,qBAAqB,EAAE,uBAAuB,EAAE;EACjH,qDAAqD,oBAAoB,EAAE;EAC3E,wCAAwC,0BAA0B,EAAE;AACtE","sourcesContent":[".navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #ffffff;\n  padding: 1rem 2rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n/* Desktop: navbar-primary se \"disuelve\" y sus hijos van directo al flex del navbar.\n   Con flex order reubicamos el zone-control-wrapper entre logo y navbar-center\n   para mantener el layout previo (back | logo | zona | filtros | lista). */\n.navbar-primary {\n  display: contents;\n}\n\n.navbar-left {\n  order: 1;\n}\n\n.navbar-left .p-button {\n  color: #fa7317;\n}\n\n.navbar-left .p-button .p-button-icon {\n  color: #fa7317;\n  font-size: 1.1rem;\n}\n\n.navbar-left .p-button:hover {\n  color: #e06312;\n  background: #fff8f4;\n}\n\n.navbar-left .p-button:hover .p-button-icon {\n  color: #e06312;\n}\n.logo {\n  order: 2;\n}\n.zone-control-wrapper {\n  order: 3;\n}\n.navbar-center {\n  order: 4;\n}\n.navbar-right {\n  order: 5;\n}\n\n/* ---------- Tablet ---------- */\n@media (max-width: 1024px) {\n  .navbar {\n    padding: 0.75rem 1rem;\n    gap: 0.5rem;\n  }\n  .logo img {\n    max-height: 28px;\n  }\n}\n\n/* ---------- Mobile ---------- */\n@media (max-width: 768px) {\n  /* Navbar: UNA sola fila, compacta. Los chips de filtros activos\n     se renderizan como barra flotante ENCIMA del mapa (no dentro del navbar). */\n  .navbar {\n    padding: 0.6rem 0.75rem;\n    gap: 0.5rem;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: flex-start;\n  }\n\n  .navbar-left,\n  .logo,\n  .zone-control-wrapper,\n  .navbar-center,\n  .navbar-right {\n    flex-shrink: 0;\n  }\n\n  /* Switch Radio/Zonas queda inline dentro del navbar.\n     Sacamos la barra de radio y el texto de conteo — la switch basta. */\n  .zone-control-wrapper {\n    margin-left: 4px !important;\n    gap: 6px !important;\n  }\n  .zone-control-wrapper .radius-controls,\n  .zone-control-wrapper .polygons-count {\n    display: none !important;\n  }\n\n  .logo img {\n    max-height: 26px;\n  }\n\n  .main-filters {\n    flex-wrap: nowrap;\n    gap: 2px;\n  }\n\n  /* Botones icon-only en mobile: Filtros outline, Lista CTA sólido. */\n  .nav-btn-filters {\n    color: #fa7317 !important;\n    background: #fff !important;\n    border: 1px solid rgba(250, 115, 23, 0.45) !important;\n    width: 40px;\n    height: 40px;\n    padding: 0 !important;\n    justify-content: center !important;\n  }\n  .nav-btn-filters--active {\n    background: #fff8f4 !important;\n    border-color: #fa7317 !important;\n  }\n  .nav-btn-filters .p-button-label {\n    display: none !important;\n  }\n  .nav-btn-filters .p-button-icon {\n    margin: 0 !important;\n    font-size: 18px;\n    color: #fa7317;\n  }\n\n  .nav-btn-list--primary {\n    color: #fff !important;\n    background: #fa7317 !important;\n    border: 1px solid #fa7317 !important;\n    box-shadow: 0 2px 6px rgba(250, 115, 23, 0.35);\n    width: 40px;\n    height: 40px;\n    padding: 0 !important;\n    justify-content: center !important;\n  }\n  .nav-btn-list .p-button-label {\n    display: none !important;\n  }\n  .nav-btn-list .p-button-icon {\n    margin: 0 !important;\n    font-size: 18px;\n    color: #fff !important;\n  }\n\n  /* Crear nuevo reporte desaparece en mobile */\n  .nav-btn-create {\n    display: none !important;\n  }\n\n  .navbar-right {\n    margin-left: auto;\n  }\n\n  /* Panel avanzado: overlay fixed por debajo del navbar (~60px). */\n  .advanced-filters-panel {\n    position: fixed;\n    top: 60px;\n    left: 0;\n    right: 0;\n    width: 100vw;\n    max-height: calc(100vh - 60px);\n    overflow-y: auto;\n    background: #fff8f4;\n    border-top: 2px solid rgba(250, 115, 23, 0.35);\n    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n    z-index: 1001;\n    padding: 12px;\n  }\n\n  .filters-grid {\n    grid-template-columns: 1fr !important;\n    gap: 12px;\n  }\n\n  /* Chips flotantes: barra fija debajo del navbar, sobre el mapa.\n     Una sola fila con scroll horizontal. */\n  .active-filters {\n    position: fixed !important;\n    top: 60px !important;\n    left: 0;\n    right: 0;\n    padding: 0.4rem 0.6rem;\n    margin: 0;\n    gap: 0.4rem;\n    flex-wrap: nowrap !important;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    white-space: nowrap;\n    background: transparent; /* flota sobre el mapa */\n    z-index: 998;\n    pointer-events: none; /* los gaps entre chips dejan pasar clicks al mapa */\n  }\n  .active-filters::-webkit-scrollbar {\n    height: 0;\n    display: none;\n  }\n  .active-filters {\n    scrollbar-width: none;\n  }\n\n  .filter-chip {\n    flex-shrink: 0;\n    pointer-events: auto; /* los chips sí son interactivos */\n    background: #fff;\n    border: 2px solid rgba(250, 115, 23, 0.55);\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n  }\n}\n\n.main-filters {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  position: relative;\n}\n\n/* Switch de modo de búsqueda Radio/Zonas */\n.search-mode-toggle {\n  display: inline-flex;\n  background: #f3f4f6;\n  border-radius: 999px;\n  padding: 2px;\n}\n\n.search-mode-toggle .smt-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.search-mode-toggle .smt-btn:hover:not(:disabled) {\n  color: #fa7317;\n}\n\n.search-mode-toggle .smt-btn.active {\n  background: #ffffff;\n  color: #fa7317;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.search-mode-toggle .smt-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.search-mode-toggle .smt-btn:focus,\n.search-mode-toggle .smt-btn:focus-visible {\n  outline: none;\n  box-shadow: none;\n}\n\n.search-mode-toggle .smt-btn i {\n  font-size: 12px;\n}\n\n.search-mode-toggle .smt-badge {\n  display: inline-block;\n  min-width: 18px;\n  padding: 0 5px;\n  background: #fa7317;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 999px;\n  text-align: center;\n  line-height: 18px;\n}\n\n/* Slider de radio — relleno progresivo naranja */\n.radius-controls .radius-slider,\n.zone-control-wrapper .radius-slider {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 160px;\n  height: 16px;\n  background: transparent;\n  cursor: pointer;\n}\n\n.radius-controls .radius-slider::-webkit-slider-runnable-track,\n.zone-control-wrapper .radius-slider::-webkit-slider-runnable-track {\n  height: 6px;\n  border-radius: 999px;\n  background: linear-gradient(\n    to right,\n    #fa7317 0%,\n    #fa7317 var(--radius-fill, 0%),\n    #ffedd5 var(--radius-fill, 0%),\n    #ffedd5 100%\n  );\n}\n\n.radius-controls .radius-slider::-webkit-slider-thumb,\n.zone-control-wrapper .radius-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  margin-top: -5px;\n  border-radius: 50%;\n  background: #fa7317;\n  border: 2px solid #fff;\n  box-shadow: 0 1px 4px rgba(250, 115, 23, 0.45);\n  cursor: pointer;\n}\n\n.radius-controls .radius-slider::-moz-range-progress,\n.zone-control-wrapper .radius-slider::-moz-range-progress {\n  height: 6px;\n  border-radius: 999px 0 0 999px;\n  background: #fa7317;\n}\n\n.radius-controls .radius-slider::-moz-range-track,\n.zone-control-wrapper .radius-slider::-moz-range-track {\n  height: 6px;\n  border-radius: 999px;\n  background: #ffedd5;\n}\n\n.radius-controls .radius-slider::-moz-range-thumb,\n.zone-control-wrapper .radius-slider::-moz-range-thumb {\n  width: 16px;\n  height: 16px;\n  border: none;\n  border-radius: 50%;\n  background: #fa7317;\n  box-shadow: 0 1px 4px rgba(250, 115, 23, 0.45);\n  cursor: pointer;\n}\n\n.transaction-filter {\n  display: flex;\n  gap: 0.5rem;\n\n  button {\n    padding: 0.5rem 1rem;\n\n    &.active {\n      margin: 0;\n      display: inline-flex;\n      cursor: pointer;\n      user-select: none;\n      align-items: center;\n      vertical-align: bottom;\n      text-align: center;\n      overflow: hidden;\n      position: relative;\n      background: #fa7317;\n      color: white;\n      border-color: #fa7317;\n      font-weight: bold;\n    }\n  }\n}\n\n.transaction-buttons {\n  display: flex;\n  gap: 0.5rem;\n\n  button {\n    padding: 0.5rem 1rem;\n\n    &.active {\n      margin: 0;\n      display: inline-flex;\n      cursor: pointer;\n      user-select: none;\n      align-items: center;\n      vertical-align: bottom;\n      text-align: center;\n      overflow: hidden;\n      position: relative;\n      background: #fa7317;\n      color: white;\n      border-color: #fa7317;\n      font-weight: bold;\n    }\n  }\n}\n.advanced-filters-panel {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: linear-gradient(180deg, #fff8f4 0%, #fff 100%);\n  padding: 0.85rem 1.25rem 1rem;\n  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);\n  border-top: 2px solid rgba(250, 115, 23, 0.4);\n  border-radius: 0 0 14px 14px;\n  z-index: 999;\n  --filter-control-h: 44px;\n}\n\n.filters-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.05fr) minmax(0, 1.35fr) minmax(0, 1.05fr) minmax(0, 1.2fr);\n  gap: 0.75rem;\n  align-items: stretch;\n}\n\n.filter-section {\n  padding: 0.9rem 0.95rem 1rem;\n  border-radius: 12px;\n  background: linear-gradient(155deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 247, 237, 0.7) 100%);\n  border: 1px solid rgba(250, 115, 23, 0.16);\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n  min-height: 0;\n}\n\n.filter-section__title {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin: 0;\n  padding-bottom: 0.45rem;\n  border-bottom: 1px solid rgba(250, 115, 23, 0.12);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #c2410c;\n  line-height: 1.2;\n}\n\n.filter-section__title i {\n  font-size: 0.78rem;\n  color: #fa7317;\n}\n\n.filter-fields-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  flex: 1;\n}\n\n.filter-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.filter-field--row {\n  display: grid;\n  grid-template-columns: 6.2rem minmax(0, 1fr);\n  align-items: center;\n  column-gap: 0.65rem;\n  min-height: 44px;\n}\n\n.filter-field--row label {\n  display: flex;\n  align-items: center;\n  align-self: center;\n  min-height: 44px;\n  margin: 0;\n  font-size: 0.82rem;\n  font-weight: 650;\n  color: #475569;\n  line-height: 1.2;\n}\n\n.filter-field--row .input-group {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  height: var(--filter-control-h);\n}\n\n.filter-field label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #64748b;\n  line-height: 1.2;\n}\n\n.price-filter-row {\n  min-height: var(--filter-control-h);\n}\n\n.price-filter-row .input-group--price {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  width: 100%;\n  height: var(--filter-control-h);\n}\n\n.styled-select--currency {\n  flex: 1 1 100%;\n  width: 100%;\n  min-width: 0;\n  height: 44px;\n  padding: 0 36px 0 14px;\n  font-size: 16px;\n  text-align: left;\n  text-align-last: left;\n  box-sizing: border-box;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%23c2410c' d='M1 1l4 4 4-4'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 14px center;\n  background-color: #fff;\n}\n\n.input-group--price .styled-input {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.filter-amenities {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.55rem;\n}\n\n.filter-amenity-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  min-height: 44px;\n  padding: 0.55rem 0.7rem;\n  border: 1px solid rgba(250, 115, 23, 0.16);\n  border-radius: 12px;\n  background: #fff;\n  color: #334155;\n  font-size: 0.86rem;\n  font-weight: 650;\n  line-height: 1.2;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  white-space: nowrap;\n}\n\n.filter-amenity-chip__icon {\n  font-size: 0.72rem;\n  line-height: 1;\n}\n\n.filter-amenity-chip:hover {\n  border-color: rgba(250, 115, 23, 0.45);\n}\n\n.filter-amenity-chip--active,\n.filter-amenity-chip--active:hover {\n  background: rgba(250, 115, 23, 0.1);\n  border-color: #fa7317;\n  color: #c2410c;\n  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.12);\n}\n\n.filter-amenity-chip:focus,\n.filter-amenity-chip:focus-visible {\n  outline: none;\n  box-shadow: none;\n}\n\n.filter-parking-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-top: 0.15rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid rgba(250, 115, 23, 0.12);\n  min-height: 44px;\n}\n\n.filter-parking-row > span {\n  font-size: 0.86rem;\n  font-weight: 650;\n  color: #334155;\n}\n\n.filter-stepper {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.filter-stepper__btn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba(250, 115, 23, 0.16);\n  border-radius: 12px;\n  background: #fff;\n  color: #c2410c;\n  font-size: 0;\n  line-height: 0;\n  cursor: pointer;\n}\n\n.filter-stepper__btn::before,\n.filter-stepper__btn--plus::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  background: currentColor;\n  border-radius: 1px;\n  transform: translate(-50%, -50%);\n}\n\n.filter-stepper__btn::before {\n  width: 12px;\n  height: 2px;\n}\n\n.filter-stepper__btn--plus::after {\n  width: 2px;\n  height: 12px;\n}\n\n.filter-stepper__btn:hover:not(:disabled) {\n  background: #fa7317;\n  color: #fff;\n}\n\n.filter-stepper__btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n  color: #94a3b8;\n}\n\n.filter-stepper__value {\n  min-width: 1.5rem;\n  text-align: center;\n  font-size: 0.95rem;\n  font-weight: 750;\n  color: #0f172a;\n  font-variant-numeric: tabular-nums;\n}\n\n.filter-parking-row label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  height: var(--filter-control-h);\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #64748b;\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.styled-input--parking {\n  flex: 0 0 4.5rem;\n  width: 4.5rem;\n  max-width: 4.5rem;\n  height: var(--filter-control-h);\n}\n\n.advanced-filters-panel input[type=\"number\"]::-webkit-inner-spin-button,\n.advanced-filters-panel input[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.advanced-filters-panel input[type=\"number\"] {\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n@media (max-width: 1280px) {\n  .filters-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .filter-section--amenities {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (max-width: 960px) {\n  .filters-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .filter-section--amenities {\n    grid-column: auto;\n  }\n\n  .filter-field--row {\n    grid-template-columns: 4.8rem 1fr;\n  }\n\n  .price-filter-row .input-group--price {\n    flex-wrap: wrap;\n    height: auto;\n    min-height: var(--filter-control-h);\n  }\n\n  .styled-select--currency {\n    flex: 1 1 100%;\n    width: 100%;\n    min-width: 0;\n  }\n}\n\n.slider-filter {\n  margin: 1rem 0;\n\n  input[type=\"range\"] {\n    width: 100%;\n  }\n}\n\n.amenities-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.5rem;\n\n  label {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.9rem;\n  }\n}\n.filter-group {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n  padding: 1rem;\n}\n\n.filter-group label {\n  font-weight: bold;\n  color: #374151;\n}\n\n.filter-group input,\n.filter-group select {\n  padding: 0.5rem;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 1rem;\n  color: #374151;\n}\n\n.filter-group input:focus,\n.filter-group select:focus {\n  outline: none;\n  border-color: #fa7317;\n  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.3);\n}\n\n.filter-actions {\n  display: flex;\n  justify-content: flex-initial;\n  gap: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #eee;\n}\n/* Selector de tipos de propiedad */\n.type-filter {\n  width: 240px !important;\n  min-width: 240px !important;\n\n  .p-multiselect-label {\n    white-space: nowrap;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    padding-right: 2rem;\n  }\n\n  .p-multiselect-token {\n    flex-shrink: 0;\n    margin: 2px;\n  }\n\n  .p-multiselect-items-wrapper {\n    &::-webkit-scrollbar {\n      height: 8px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #ccc;\n      border-radius: 4px;\n    }\n  }\n}\n\n/* Contenedor de chips con scroll horizontal */\n.p-multiselect-panel .p-multiselect-items {\n  display: flex !important;\n  flex-wrap: nowrap !important;\n  overflow-x: auto !important;\n  padding-bottom: 8px;\n}\n\n/* Panel desplegable más ancho */\n.property-types-panel {\n  min-width: 400px !important;\n\n  .p-multiselect-item {\n    white-space: nowrap;\n  }\n}\n\n/* Scroll horizontal para los chips seleccionados */\n.p-multiselect-label-container {\n  overflow-x: auto !important;\n  flex-wrap: nowrap !important;\n  padding-bottom: 4px;\n\n  &::-webkit-scrollbar {\n    height: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #ddd;\n    border-radius: 2px;\n  }\n}\n/* properties-sidebar */\n.properties-sidebar {\n  width: min(90vw, 600px) !important;\n  height: 100vh !important;\n  transition: transform 0.3s ease !important;\n\n  &.p-sidebar {\n    box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);\n    border-left: 1px solid #ddd;\n  }\n\n  .p-sidebar-content {\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    overflow: hidden;\n  }\n}\n\n.sidebar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  border-bottom: 1px solid #eee;\n  background: #fff;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n\n  h3 {\n    margin: 0;\n    font-size: 1.2rem;\n  }\n\n  button {\n    color: #666;\n\n    &:hover {\n      color: #3b82f6;\n    }\n  }\n}\n/* SCOPED al .navbar — antes era un selector global .p-button que pisaba\n   TODOS los botones de PrimeReact en la app, incluyendo Generar PDF /\n   Excel del editor del informe. Esos quedaban como letras grises sin\n   contorno porque hereaban background:none + border:none. */\n.navbar .p-button {\n  color: #6b7280;\n  background: none;\n  border: none;\n  padding: 0.75rem 1.25rem;\n  font-size: 1rem;\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    border-color 0.2s,\n    box-shadow 0.2s;\n  border-radius: 6px;\n}\n\n/* Botones de acción del navbar — jerarquía visual */\n.navbar .nav-btn-filters,\n.navbar .nav-btn-create,\n.navbar .nav-btn-list {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.55rem 1rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  border-radius: 8px;\n  border: 1px solid transparent;\n}\n\n.navbar .nav-btn-filters {\n  color: #fa7317;\n  background: #fff;\n  border-color: rgba(250, 115, 23, 0.45);\n}\n\n.navbar .nav-btn-filters:hover,\n.navbar .nav-btn-filters--active {\n  color: #fa7317;\n  background: #fff8f4;\n  border-color: #fa7317;\n}\n\n.navbar .nav-btn-filters:focus,\n.navbar .nav-btn-filters:focus-visible,\n.navbar .nav-btn-filters.p-focus,\n.navbar .nav-btn-create:focus,\n.navbar .nav-btn-create:focus-visible,\n.navbar .nav-btn-create.p-focus,\n.navbar .nav-btn-list:focus,\n.navbar .nav-btn-list:focus-visible,\n.navbar .nav-btn-list.p-focus,\n.navbar .p-button-text:focus,\n.navbar .p-button-text:focus-visible,\n.navbar .p-button-text.p-focus {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.navbar .nav-btn-filters .p-button-icon {\n  color: #fa7317;\n}\n\n.navbar .nav-btn-create {\n  color: #374151;\n  background: #f3f4f6;\n  border-color: #e5e7eb;\n}\n\n.navbar .nav-btn-create:hover {\n  color: #374151;\n  background: #e9ecef;\n  border-color: #d1d5db;\n}\n\n.navbar .nav-btn-create .p-button-icon {\n  color: #6b7280;\n}\n\n.navbar .nav-btn-list--primary {\n  color: #fff;\n  background: #fa7317;\n  border-color: #fa7317;\n  box-shadow: 0 2px 8px rgba(250, 115, 23, 0.35);\n  padding: 0.6rem 1.15rem;\n}\n\n.navbar .nav-btn-list--primary:hover {\n  color: #fff;\n  background: #e06312;\n  border-color: #e06312;\n  box-shadow: 0 4px 12px rgba(250, 115, 23, 0.4);\n}\n\n.navbar .nav-btn-list--primary .p-button-icon {\n  color: #fff;\n}\n\n.navbar .nav-btn-list--primary .p-button-label {\n  color: #fff;\n}\n.active-filters {\n  position: fixed;\n  top: 70px;\n  left: 0;\n  right: 0;\n  padding: 1rem 2rem;\n  z-index: 1;\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.filter-chip {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: #ffffff;\n  padding: 0.1rem 1rem;\n  border-radius: 20px;\n  font-size: 0.7rem;\n  border: 2px solid rgba(250, 115, 23, 0.55);\n}\n\n.button-group-filter {\n  margin: 1rem 0;\n}\n\n.button-group {\n  display: flex;\n  gap: 0.4rem;\n  flex-wrap: wrap;\n}\n\n.advanced-filters-panel .button-group .p-button {\n  min-width: 0;\n  flex: 1 1 calc(50% - 0.2rem);\n  padding: 0.4rem 0.5rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n  border-radius: 999px;\n  border: 1.5px solid #e2e8f0;\n  background: #f8fafc;\n  color: #475569;\n}\n\n.advanced-filters-panel .button-group .p-button:hover {\n  border-color: rgba(250, 115, 23, 0.45);\n  color: #c2410c;\n  background: #fff8f4;\n}\n\n.advanced-filters-panel .button-group .p-button.active {\n  background: #fa7317;\n  color: #fff;\n  border-color: #fa7317;\n  box-shadow: 0 2px 6px rgba(250, 115, 23, 0.3);\n}\n\n.styled-input {\n  flex: 1 1 0;\n  min-width: 0;\n  width: 100%;\n  height: 44px;\n  padding: 0 14px;\n  border: 1px solid rgba(250, 115, 23, 0.16);\n  border-radius: 12px;\n  text-align: left;\n  font-size: 16px;\n  font-weight: 500;\n  color: #0f172a;\n  background: #fff;\n  box-sizing: border-box;\n  line-height: 1.2;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.styled-input:focus {\n  outline: none;\n  border-color: #fa7317;\n  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.12);\n}\n\n.styled-input--compact {\n  max-width: 100%;\n}\n\n.styled-select {\n  width: 100%;\n  height: 44px;\n  padding: 0 36px 0 14px;\n  border: 1px solid rgba(250, 115, 23, 0.16);\n  border-radius: 12px;\n  background-color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  color: #0f172a;\n  box-sizing: border-box;\n  line-height: 1.2;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.styled-select:focus {\n  outline: none;\n  border-color: #fa7317;\n  box-shadow: 0 0 0 3px rgba(250, 115, 23, 0.12);\n}\n\n.small-input {\n  width: 60px !important;\n  max-width: 60px;\n  margin-top: 5px;\n}\n\n.price-filter-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.input-group {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  flex-wrap: nowrap;\n  width: 100%;\n}\n\n.input-group .separator {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  align-self: center;\n  height: var(--filter-control-h, 2rem);\n  color: #c2410c;\n  font-weight: 600;\n  font-size: 0.85rem;\n  line-height: 1;\n}\n\n.currency-selector,\n.price-inputs {\n  width: 100%;\n}\n.logo img {\n  height: 40px; /* Ajusta según tu diseño */\n  width: auto;\n  cursor: pointer;\n}\n\n/* Home navigation: brand a la izquierda, zona y acciones a la derecha. */\n.home-page .navbar {\n  position: relative;\n  inset: auto;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  flex: 0 0 auto;\n  padding: 12px 20px;\n  gap: 10px 16px;\n  z-index: 20;\n  box-shadow: none;\n  border-bottom: 1px solid #e5e7eb;\n  background: #fff;\n}\n.home-page .navbar-brand {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  min-width: 0;\n  flex: 0 0 auto;\n}\n.home-page .navbar-tools {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-left: auto;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n.home-page .navbar-center { display: contents; }\n.home-page .navbar-left .p-button { width: 32px; height: 38px; padding: 0; justify-content: center; }\n.home-page .navbar .logo { display: flex; align-items: center; margin: 0; padding: 0; }\n.home-page .navbar .logo img { display: block; width: 108px; height: auto; max-height: 36px; object-fit: contain; }\n.home-page .main-filters { gap: 12px; flex-shrink: 0; }\n.home-page .navbar .nav-btn-filters,\n.home-page .navbar .nav-btn-create {\n  display: inline-flex !important;\n  min-height: 40px;\n  padding: 9px 14px;\n  font-size: 13px;\n  white-space: nowrap;\n}\n.home-page .navbar .nav-btn-filters { width: auto; height: auto; }\n.home-page .navbar .nav-btn-filters .p-button-label { display: inline !important; }\n.home-page .navbar .nav-btn-filters .p-button-icon { margin-right: 6px !important; }\n.nav-filters-wrap { position: relative; display: inline-flex; }\n@keyframes nav-filters-updated {\n  0% { box-shadow: 0 0 0 0 rgba(250, 115, 23, 0.4); }\n  45% { box-shadow: 0 0 0 7px rgba(250, 115, 23, 0); background: #fff7ed; }\n  100% { box-shadow: 0 0 0 0 rgba(250, 115, 23, 0); }\n}\n@keyframes nav-filters-count-pop {\n  0% { transform: scale(1); }\n  35% { transform: scale(1.2); }\n  100% { transform: scale(1); }\n}\n.nav-filters-wrap--updated .nav-btn-filters {\n  animation: nav-filters-updated 0.9s ease;\n}\n.nav-filters-wrap--updated .nav-filters-count {\n  animation: nav-filters-count-pop 0.9s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-filters-wrap--updated .nav-btn-filters,\n  .nav-filters-wrap--updated .nav-filters-count {\n    animation: none;\n  }\n}\n.nav-filters-count {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  z-index: 1;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: #c2410c;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 18px;\n  text-align: center;\n  pointer-events: none;\n}\n.home-page .zone-control-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1 1 280px;\n  max-width: 460px;\n  min-width: 0;\n  margin: 0 !important;\n  padding: 6px 10px;\n  border: 1px solid rgba(250, 115, 23, 0.16);\n  border-radius: 12px;\n  background: linear-gradient(155deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 247, 237, 0.7) 100%);\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);\n}\n.home-page .search-mode-toggle { flex: 0 0 auto; background: rgba(255, 255, 255, 0.7); }\n.home-page .search-mode-toggle .smt-btn { padding: 7px 11px; font-size: 12px; }\n.home-page .zone-control-wrapper .radius-controls { display: flex !important; align-items: center; gap: 8px; flex: 1; min-width: 0; }\n.home-page .radius-controls__value { min-width: 52px; color: #78716c; font-size: 12px; text-align: right; }\n.home-page .radius-slider { flex: 1; min-width: 80px; width: 100%; }\n\n.filter-drawer-backdrop {\n  position: fixed;\n  top: var(--home-nav-bottom, 72px);\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 39;\n  border: 0;\n  padding: 0;\n  background: rgba(15, 23, 42, 0.28);\n  cursor: pointer;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.42s ease;\n}\n.filter-drawer-backdrop.is-open {\n  opacity: 1;\n  pointer-events: auto;\n}\n.home-page .filter-drawer {\n  position: fixed;\n  top: var(--home-nav-bottom, 72px);\n  right: 0;\n  bottom: 0;\n  left: auto;\n  z-index: 40;\n  display: flex;\n  flex-direction: column;\n  width: min(100%, clamp(440px, 44vw, 680px));\n  max-height: none;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  border: 0;\n  border-left: 1px solid rgba(250, 115, 23, 0.16);\n  border-radius: 0;\n  background: #fff;\n  box-shadow: -16px 0 40px rgba(15, 23, 42, 0.14);\n  transform: translateX(100%);\n  pointer-events: none;\n  transition: transform 0.42s cubic-bezier(0.22, 1, 0.36, 1);\n}\n.home-page .filter-drawer.is-open {\n  transform: translateX(0);\n  pointer-events: auto;\n}\n.filter-drawer__form {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n.filter-drawer .filters-grid { grid-template-columns: 1fr; }\n.filter-drawer .price-filter-row,\n.filter-drawer .price-filter-row .input-group--price {\n  height: auto;\n  min-height: 0;\n}\n.filter-drawer .price-filter-row .input-group--price {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);\n  gap: 8px;\n}\n.filter-drawer .styled-select--currency { grid-column: 1 / -1; }\n.filter-drawer .active-filters {\n  position: static !important;\n  inset: auto !important;\n  top: auto !important;\n  right: auto !important;\n  left: auto !important;\n  display: flex;\n  flex-wrap: wrap !important;\n  gap: 8px;\n  width: auto;\n  max-height: none;\n  margin: 0 0 14px;\n  padding: 0;\n  overflow: visible;\n  background: transparent;\n  pointer-events: auto;\n  z-index: auto;\n}\n.filter-drawer .filter-chip {\n  flex-shrink: 1;\n  max-width: 100%;\n  padding: 4px 4px 4px 10px;\n  border: 1px solid rgba(250, 115, 23, 0.22);\n  border-radius: 12px;\n  background: #fff;\n  color: #334155;\n  box-shadow: none;\n  font-size: 12px;\n}\n.filter-drawer .filter-chip span {\n  display: block;\n  min-width: 0;\n  max-width: min(100%, 280px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.filter-drawer .filter-chip .p-button {\n  flex-shrink: 0;\n  min-width: 28px;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  justify-content: center;\n}\n.filter-editor-heading { display: flex; align-items: center; justify-content: space-between; flex-shrink: 0; padding: 16px 20px 12px; gap: 16px; }\n.filter-editor-heading h2 { margin: 0; color: #334155; font-size: 16px; }\n.filter-editor-heading p { margin: 5px 0 0; color: #78716c; font-size: 12px; }\n.filter-editor-close { width: 32px; height: 32px; flex: 0 0 auto; border: 0; border-radius: 8px; color: #78716c; background: #f2ede7; cursor: pointer; }\n.filter-editor-body { min-height: 0; overflow-y: auto; padding: 0 20px 16px; overscroll-behavior: contain; }\n.filter-editor-footer { display: flex; align-items: center; justify-content: space-between; gap: 16px; flex-shrink: 0; padding: 12px 20px; border-top: 1px solid #f0dfd0; background: #fff; }\n.filter-editor-status { font-size: 12px; color: #78716c; }\n.filter-editor-error { color: #b91c1c; }\n.filter-editor-actions { display: flex; align-items: center; gap: 10px; flex-shrink: 0; }\n.filter-editor-actions button { min-height: 44px; padding: 9px 16px; border-radius: 12px; font: inherit; font-size: 14px; font-weight: 650; cursor: pointer; }\n.filter-drawer .filter-editor-footer { flex-direction: column; align-items: stretch; gap: 10px; }\n.filter-drawer .filter-editor-actions { display: grid; grid-template-columns: 1fr 1.35fr; }\n.filter-editor-cancel { color: #c2410c; background: #fff; border: 1px solid rgba(250, 115, 23, 0.45); }\n.filter-editor-apply {\n  color: #fff;\n  border: none;\n  background: linear-gradient(135deg, #fa7317 0%, #c2410c 100%);\n  box-shadow: 0 4px 12px rgba(250, 115, 23, 0.25);\n}\n.filter-editor-apply:disabled { opacity: .5; cursor: not-allowed; box-shadow: none; }\n.filter-editor-apply:hover:not(:disabled) {\n  color: #fff;\n  background: linear-gradient(135deg, #fa7317 0%, #c2410c 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px rgba(250, 115, 23, 0.35);\n}\n.filter-editor-actions button:focus-visible { outline: 2px solid #a65320 !important; outline-offset: 3px; }\n\n.polygon-expansion { flex: 1; min-width: 0; }\n.polygon-expansion__heading { display: flex; justify-content: space-between; align-items: center; gap: 8px; font-size: 11px; color: #78716c; }\n.polygon-expansion__heading label { font-weight: 600; }\n.polygon-expansion__heading output { color: #a85d2d; font-weight: 700; white-space: nowrap; }\n.polygon-expansion__row { display: flex; align-items: center; gap: 7px; }\n.polygon-expansion__reset { flex: 0 0 26px; width: 26px; height: 26px; padding: 0; border: 1px solid #f2d6bd; border-radius: 6px; background: #fffaf5; color: #a85d2d; cursor: pointer; }\n.polygon-expansion__reset:disabled { opacity: .4; cursor: default; }\n.polygon-expansion__reset:focus-visible, .home-page .radius-slider:focus-visible { outline: 2px solid #c8753c !important; outline-offset: 3px; }\n\n@media (max-width: 980px) {\n  .home-page .navbar-tools { display: contents; }\n  .home-page .navbar-brand { order: 1; }\n  .home-page .main-filters { order: 2; margin-left: auto; }\n  .home-page .zone-control-wrapper {\n    order: 3;\n    flex: 1 1 100%;\n    max-width: none;\n  }\n}\n@media (max-width: 600px) {\n  .home-page .navbar { padding: 10px 12px; gap: 10px; }\n  .home-page .navbar .logo img { width: 86px; max-height: 30px; }\n  .home-page .navbar-left .p-button { width: 26px; }\n  .home-page .main-filters { gap: 8px; }\n  .home-page .navbar .nav-btn-filters { min-height: 40px; padding: 8px 10px; }\n  .home-page .navbar .nav-btn-create { width: 40px; height: 40px; min-height: 40px; padding: 0; justify-content: center; }\n  .home-page .navbar .nav-btn-create .p-button-label { display: none; }\n  .home-page .navbar .nav-btn-create .p-button-icon { margin: 0; }\n  .home-page .zone-control-wrapper { gap: 10px !important; padding: 7px 8px; }\n  .home-page .search-mode-toggle .smt-btn { padding: 6px 8px; font-size: 11px; gap: 4px; }\n  .home-page .filter-drawer { width: 100%; border-left: 0; }\n  .filter-editor-heading { padding: 12px; }\n  .filter-editor-heading h2 { font-size: 15px; }\n  .filter-editor-body { padding: 0 12px 12px; }\n  .filter-editor-footer { padding: 10px 12px; }\n  .filter-field--row { grid-template-columns: 1fr; row-gap: 6px; }\n  .filter-field--row label { min-height: 0; }\n}\n@media (prefers-reduced-motion: reduce) {\n  .filter-drawer-backdrop,\n  .home-page .filter-drawer {\n    transition: none;\n  }\n}\n@media (max-width: 420px) {\n  .home-page .navbar .nav-btn-filters .p-button-label { display: none !important; }\n  .home-page .navbar .nav-btn-filters { width: 40px; height: 40px; padding: 0 !important; justify-content: center; }\n  .home-page .navbar .nav-btn-filters .p-button-icon { margin: 0 !important; }\n  .filter-drawer .filter-editor-actions { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
